import styled from "styled-components";

export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const ModalTitle = styled.p`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.neutral["900"]};
  text-align: center;
  margin: 12px 0 0 0;
`;

export const ModalDescription = styled.p`
  text-align: center;
  margin: 8px 0 24px 0;
  color: ${({ theme }) => theme.colors.neutral["600"]};
`;

export const WhatsappInformation = styled.p`
  margin: 16px 0 0 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
`;
